import { Box, Typography } from "@mui/material";

export default function PayrIframeModal({ data }) {
  const iframeUrl = data?.iframeUrl;

  if (!iframeUrl) {
    return (
      <Typography sx={{ color: "#a94442", padding: "0.5rem" }}>
        Payr session is not available. Please try again.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", height: { xs: "70vh", md: "75vh" } }}>
      <iframe
        title="Payr Checkout"
        src={iframeUrl}
        allow="payment"
        style={{ width: "100%", height: "100%", border: 0, display: "block" }}
      />
    </Box>
  );
}
